import React, { FC, Fragment } from 'react';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { Colors } from '../../styles/colors';

const BreadCrumbWrapper = styled.div`
  margin-bottom: 3rem;

  font-size: .75rem;
`;

const Separator = styled.span`
  padding: 0 .5rem;
`;

const StyledLink = styled(NavLink)`
  cursor: pointer;
  &:hover {
    @media (pointer: fine) {
      color: ${Colors.tertiary};
    }
  }

  &.active {
    pointer-events: none;
    cursor: default;

    &:hover {
      @media (pointer: fine) {
        color: inherit;
      }
    }
  }
`;

export interface BreadCrumbItem {
  title: string;
  path: string;
}
interface Props {
  items: BreadCrumbItem[];
}
export const BreadCrumb: FC<Props> = (props) => {
  const { items } = props;

  return (
    <>
      {
        items.length > 0 &&
        <BreadCrumbWrapper>
          {
            items.map((item, index) => {
              const view = (
                <StyledLink exact to={item.path} key={index}>{ item.title }</StyledLink>
              )

              if (index > 0) {
                return (
                  <Fragment key={index}>
                    <Separator>{'>'}</Separator>
                    { view }
                  </Fragment>
                )
              }
              return view;
            })
          }
        </BreadCrumbWrapper>
      }
    </>
  );
};
